import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledUserName = styled.div`
  color: #fff;
  font-size: 0.98rem;
  font-weight: 400;
  letter-spacing: -0.02em;
`;

const UserName = ({ name }) => <StyledUserName>{name}</StyledUserName>;

UserName.propTypes = {
  name: PropTypes.string.isRequired,
};

export default UserName;
